import React from 'react';
import { Sparkles, Heart, Award } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="about-section py-20 lg:py-32">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="about-image-wrapper">
              <img 
                src="/logo.jpg"
                alt="Taste T Pistachio Baker"
                className="about-image"
              />
              <div className="about-floating-badge">
                <Award className="text-gold" size={24} />
                <span className="font-semibold text-olive">Young Entrepreneur</span>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-6 order-1 lg:order-2">
            <div>
              <span className="section-label">Our Story</span>
              <h2 className="section-title mt-3">Baked with Passion,
                <span className="block text-gold">Inspired by Flavor</span>
              </h2>
            </div>

            <div className="space-y-4 text-olive-dark text-lg leading-relaxed">
              <p>
                Welcome to Taste T Pistachio! Founded by a passionate 13-year-old baker right here in Clermont, FL, 
                our journey began with a simple love for the rich, nutty flavor of pistachios and a dream to share 
                that joy with our community.
              </p>
              <p>
                Every treat is handcrafted with the finest all-natural, organic ingredients. From our signature 
                pistachio cakes to our delightful cookies, each creation is made with care, creativity, and a 
                whole lot of heart.
              </p>
              <p>
                We believe in the magic of homemade goodness - no artificial flavors, no shortcuts, just pure, 
                authentic pistachio perfection that brings smiles to every occasion.
              </p>
            </div>

            {/* Feature Highlights */}
            <div className="grid sm:grid-cols-3 gap-4 pt-6">
              <div className="feature-card">
                <Sparkles className="text-gold mb-2" size={28} />
                <h4 className="font-semibold text-olive mb-1">All Natural</h4>
                <p className="text-sm text-olive-dark">Pure organic ingredients</p>
              </div>
              <div className="feature-card">
                <Heart className="text-gold mb-2" size={28} />
                <h4 className="font-semibold text-olive mb-1">Made with Love</h4>
                <p className="text-sm text-olive-dark">Handcrafted in small batches</p>
              </div>
              <div className="feature-card">
                <Award className="text-gold mb-2" size={28} />
                <h4 className="font-semibold text-olive mb-1">Custom Orders</h4>
                <p className="text-sm text-olive-dark">Personalized for you</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
